// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip___k9KYM","title":"title___pEDSn","description":"description___SsP_H","cellText":"cellText___y2awe"};